import { useState } from "react";
import { Icon } from "assets/Icon";
import SelectedValueModal from "./SelectedValueModal";
import FuncButtonStyled from "components/FuncButton/FuncButtonStyled";

type SelectedModalButtonProps = {
	companyId: string | number;
	questionId: string | number;
	selectedData: any[];
	type: string;
};

export const SelectedModalButton = ({
	type,
	questionId,
	companyId,
	selectedData,
}: SelectedModalButtonProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleButtonClick = () => {
		setIsOpen(true);
	};

	return (
		<>
			<FuncButtonStyled
				type="button"
				onClick={handleButtonClick}
			>
				Selected {type === "project_experience" ? "Projects" : "Personnels"}
				<Icon
					icon="arrow-up-right"
					sx={undefined}
					size={16}
					width={16}
					height={16}
					strokeWidth={2}
					className=""
					color={undefined}
					isDanger={false}
				/>
			</FuncButtonStyled>
			<SelectedValueModal
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				type={type}
				questionId={questionId}
				companyId={companyId}
				selectedData={selectedData}
			/>
		</>
	);
};
